<template>
  <div class="ab-server warp">
    <div class="block-title" data-aos="fade">提供全方位运营服务</div>
    <div class="block-subtitle" data-aos="fade" data-aos-delay="100">
      有效降低企业各项运营成本
    </div>
    <div
      class="server-list"
      id="server-list"
      data-aos="fade-down"
      data-aos-delay="100"
    >
      <!--<a-affix :offset-top="top" style="z-index: 999">-->
      <div class="server-price" id="server-price">
        <a-row>
          <a-col :span="3">
            <div class="server-pro">
              <span class="fontsize20">产品服务</span>
            </div>
          </a-col>
          <a-col :span="21">
            <a-row>
              <a-col :span="6">
                <div class="server-pro">
                  <span class="fontsize20">内容</span>
                </div>
              </a-col>
              <!-- <a-col :span="11">
                <div class="server-pro">
                  <img src="@/assets/product/套餐.png" />
                  <span class="fontsize20">说明</span>
                </div>
              </a-col> -->
              <a-col :span="6">
                <div class="price-val flex-col justify-between">
                  <div class="item-name fontsize22">工具版</div>
                  <div class="item-subtitle fontsize24">
                    <span>（自实施）</span>
                  </div>
                  <!-- <div class="item-try-btn">
                <a
                  href="https://crm.cnabke.com/#/passport/register"
                  data-source="p"
                  onmouseover="linkDataSource(this)"
                  a-type="register"
                  target="_blank"
                  >立即体验</a
                >
              </div> -->
                </div>
              </a-col>
              <a-col :span="6">
                <div class="price-val flex-col justify-between">
                  <div class="item-name fontsize22">专业版</div>
                  <div class="item-subtitle fontsize24">
                    <span>（人工辅助实施）</span>
                  </div>
                  <!-- <div class="item-try-btn">
                <a
                  href="https://crm.cnabke.com/#/passport/register"
                  data-source="p"
                  onmouseover="linkDataSource(this)"
                  a-type="register"
                  target="_blank"
                  >立即体验</a
                >
              </div> -->
                </div>
              </a-col>
              <a-col :span="6">
                <div class="price-val flex-col justify-between">
                  <div class="item-name fontsize22">铂金版</div>
                  <div class="item-subtitle fontsize24">
                    <span>（人工代运营）</span>
                  </div>
                  <!-- <div class="item-try-btn orangeBg">
                <a
                  href="https://crm.cnabke.com/#/passport/register"
                  data-source="p"
                  onmouseover="linkDataSource(this)"
                  a-type="register"
                  target="_blank"
                  >立即体验</a
                >
              </div> -->
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
      <!--</a-affix>-->
      <div class="server-content">
        <a-row class="server-content-item" v-for="item in serverList">
          <a-col :span="3">
            <div class="item-name item-name-title">{{ item.title }}</div>
            <div class="item-subtitle">
              <span>（{{ item.subTitle }}）</span>
            </div>
          </a-col>
          <a-col :span="21" style="border-left: 1px solid #E4E4E5;">
            <a-row
              v-for="node in item.contentList"
              style="border-bottom: 1px solid #E4E4E5;align-items: center;
    display: flex;"
            >
              <a-col :span="6" class="borderRight">
                <div class="item-name">
                  {{ node.title }}
                  <a-popover>
                    <template slot="content">
                      <div class="popover-desc" v-html="node.desc"></div>
                    </template>
                    <a-icon
                      style="color: rgba(0, 0, 0, 0.6)"
                      type="question-circle"
                    />
                  </a-popover>
                </div>
                <div class="item-subtitle" v-if="node.subTitle">
                  <span>（{{ node.subTitle }}）</span>
                </div>
              </a-col>
              <!-- <a-col :span="11" class="borderRight">
                <div class="item-desc">{{ node.desc }}</div>
              </a-col> -->
              <a-col :span="6" class="borderRight">
                <div class="item-status">
                  <i v-if="node.package1" class="iconfont icon-duihao2"></i>
                  <span v-else class="empty">一</span>
                </div>
              </a-col>
              <a-col :span="6" class="borderRight">
                <div class="item-status">
                  <i v-if="node.package2" class="iconfont icon-duihao2"></i>
                  <span v-else class="empty">一</span>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="item-status">
                  <i v-if="node.package3" class="iconfont icon-duihao2"></i>
                  <span v-else class="empty">一</span>
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import Abbutton from "@/components/Abbutton.vue";
export default {
  data() {
    return {
      navBarFixed: false,
      abHideElement: false,
      top: 57,
      serverList: [
        {
          title: "营销管理",
          subTitle: "智能化辅助增效",
          contentList: [
            {
              title: "基础功能",
              subTitle: "团队管理工具",
              desc:
                "提供优质营销<strong>团队管理，角色权限、公司文件、消息提醒</strong>等功能，保障业务有效开展。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "智能助手",
              subTitle: "工作必备工具",
              desc:
                "<strong>智能专业对话：</strong>提供高效的翻译、数据学习、资料查询、方案制定和疑难问题解决等业务信息支持；\n<strong>智能绘画设计：</strong>快速生成高质量的营销图片，满足您的营销图片需求；\n<strong>智能应用市场：</strong>提供专业外贸应用工具，为您生成精准的报价单、订单确认书、保险单、装箱单、销售合同和市场调研报告。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "营销内容",
              subTitle: "内容管理工具",
              desc:
                "高效管理和<strong>AI生成</strong>的高质量<strong>营销内容和素材</strong>，为外贸业务提供全面支持。包括企业<strong>品牌信息、产品管理、营销主题、动态文章、常见问题解答（FAQ）、营销话术、售后服务信息、案例评价及应用场景</strong>等多种信息和资料，进行系统化管理并实现自动多语言翻译。全方位提升企业品牌力，助力全球市场拓展。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "经验策略",
              subTitle: "决策辅助工具",
              desc:
                "为您提供全面适合的经验策略支撑，包含：<strong>营销经验、目标市场、目标受众、营销策略、相关资讯、竞品管理、营销分析</strong>等功能，帮助您及时有效的了解市场动态和趋势，快速准确的做出营销决策，先他人一步提升公司营销实力",
              package1: true,
              package2: true,
              package3: true,
            },
          ],
        },
        {
          title: "品牌推广引流",
          subTitle: "企业品牌形象保障",
          contentList: [
            {
              title: "搜索引擎优化SEO",
              subTitle: "独立站-智能建站",
              desc:
                "<strong>提高自然搜索排名：</strong>通过优化网站内容和结构，提升在搜索引擎结果页面（SERP）中的排名。\n<strong>长效性：</strong>一旦达到较好的排名，通常可以持续较长时间，而维护成本相对较低。\n<strong>高质量流量：</strong>通过有针对性的关键词和内容优化，吸引已经对产品或服务感兴趣的潜在客户。\n通过我们的<strong>智能建站系统：</strong>\n<strong>智能建站：</strong>无需技术背景即可一键生成高质量网页。我们提供直观易用的编辑工具，根据您的需求定制营销内容，使您的网站脱颖而出。即使不满意，也能快速编辑和发布，确保内容始终符合您的期望。\n<strong>智能SEO：</strong>系统自动优化每个网页的SEO性能，让您的网站在搜索引擎结果中排名靠前。我们确保您的网站能够达到Google官方SEO评分90+，使其在同行业竞争中占据优势。\n<strong>网站数据分析优化：</strong>我们提供全面的流量和网站分析工具，详细追踪每个页面的数据。包括关键词表现、内容优化、提交收录、曝光量、点击量、访客量、访问轨迹和操作行为。通过精准的数据统计和分析，帮助您精确把握网站表现，快速优化内容和策略，大幅提升询盘和转化率，让您轻松实现业务增长。\n<strong>独立站</strong>是企业对外的<strong>名片</strong>，体现着<strong>品牌形象</strong>和<strong>企业实力</strong>。建立一个独立站不仅是必要的，更能有效提升品牌影响力，为企业的国际化提供坚实保障。通过独立站，企业可以展示独特的价值，赢得全球客户的<strong>信任与合作</strong>，同时也是您广告投放的根本",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "社交媒体运营",
              subTitle: "Facebook、Linkedin",
              desc:
                "<strong>品牌互动：</strong>通过与关注者互动，增加品牌的亲和力和忠诚度。\n<strong>广泛覆盖：</strong>利用平台的庞大用户基数，快速传播品牌信息。\n<strong>内容多样性：</strong>可以分享各种形式的内容，如文字、图片、视频、直播等，增加宣传效果。\n我们已成功获得<strong>Facebook</strong>和<strong>LinkedIn</strong>的官方授权，并通过API将这两个平台的<strong>主页管理、帖子发布和反馈互动</strong>完美集成到我们的系统中。现在，您只需要在一个页面上进行简单的操作，就能高效地管理<strong>社交媒体账号</strong>及与<strong>粉丝互动</strong>，大幅提升品牌运营效率。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "智能内容营销",
              subTitle: "智能创作、自动执行",
              desc: `<strong>提供价值：</strong>通过发布有价值的内容（如行业报告、案例分析、使用指南），吸引和保留客户。\n<strong>建立权威：</strong>高质量的内容帮助树立企业在行业中的权威地位。\n<strong>提升SEO效果：</strong>优化的内容可以提高搜索引擎排名，为网站带来更多自然流量。\n我们基于先进技术，实现了<strong>全智能自动化内容营销</strong>，不再依赖人力干预。通过<span style="color: red">独立站、Facebook、LinkedIn和电子邮件</span>等平台，我们的系统可以全自动执行<strong>日常内容营销推广和在线沟通回复</strong>。这不仅高效，而且成本低廉，帮助您轻松应对耗费人力的内容营销任务，显著提升<strong>营销效率和服务体验</strong>。`,
              package1: false,
              package2: false,
              package3: true,
            },
          ],
        },
        {
          title: "工具或数据获客",
          subTitle: "快速获取潜在客户",
          contentList: [
            {
              title: "商机监控",
              desc:
                "商机实时探测器！用先进的自动化技术，我们将全球主要<strong>社交媒体</strong>整合到系统中，通过监控<strong>贴子和评论</strong>发现那些隐藏的、有价值的商机。让您不再错过任何一个潜在顾客，不再落后竞争对手半步，赢在起跑线上！",
              package1: false,
              package2: false,
              package3: true,
            },
            {
              title: "客户搜索",
              desc:
                "我们提供<strong>海关数据、全球买家、联系人邮箱</strong>等信息查询，助您迅速找到潜在客户，提升获客效率。全面完善客户资料，支持深入背景调查，让您对客户了如指掌。助力外贸人轻松开启全球市场旅程，赢在每一步！现在就试用，体验商业成功的新高度。",
              package1: false,
              package2: false,
              package3: false,
            },
          ],
        },
        {
          title: "客户管理",
          subTitle: "客户高效转化和口碑",
          contentList: [
            {
              title: "客户筛选分配",
              desc:
                "客户筛选分配阶段，是<strong>客户开发的第一步</strong>，它在此阶段通过关键指标（如基础信息、区域、公司规模、采购历史等等）筛选适合的潜在客户。通过<strong>智能算法与自动化分配规则</strong>，系统能将筛选后的客户准确分配给合适的销售代表。这样可以确保业务资源的有效利用，<strong>提升客户转化率</strong>。同时，配备的自动提醒功能，让销售代表能够及时跟进，不错失任何潜在商机。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "线索管理培育",
              desc:
                "在线索管理培育阶段，销售团队通过各种互动（如邮件、电话、社交媒体等）与客户<strong>建立初步联系</strong>，并根据客户反应和需求情况进一步深化关系。软件提供<strong>智能分级和自动评分</strong>功能，将线索分为档案评级、意向评级、资质潜力三种，并通过自定<strong>标签管理</strong>，使销售团队能集中资源在高潜力客户身上。此外，数据分析功能帮助销售团队跟踪每个线索的转化进程，并调整策略，提高转化率。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "商机管理开发",
              desc:
                "商机管理开发阶段，是将已经被识别为<strong>有商机的潜在客户</strong>，转化为实际业务的关键阶段。在这里提供全面的商机跟踪工具，包括<strong>商机阶段管理、预测分析、定制化报价单生成</strong>等。通过这些功能，销售团队得以全面掌握所需信息，制定针对性销售策略，从而<strong>提高谈判成功率</strong>。并且，借助自动提醒机制，销售人员能按时跟进商机，并作出即时回复，大大抓住每一个商机，完成成交。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "售后服务支持",
              desc:
                "售后服务支持阶段，是<strong>提升客户满意度和忠诚度</strong>的重要环节。在此阶段，系统跟踪和记录客户的<strong>售后反馈和服务请求</strong>，确保问题得到快速解决。通过创建工单管理系统，客户咨询和投诉能高效被分配到合适人员处理，并追踪每个服务请求的处理进程，提高响应速度。除此之外，系统还提供客户<strong>满意度调查和分析工具</strong>，帮助公司更好地了解客户需求并做出相应改进。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "通讯工具方式",
              desc:
                "提供多种便捷的通讯方式，包括<strong>邮件、电话</strong>和<strong>WhatsApp</strong>，让您可以轻松与客户保持紧密联系。通过整合这些沟通渠道，我们帮助您实现高效的订单跟进与转化，确保每一个客户需求都得到及时回应，提升客户满意度，从而大幅提高订单成功率。无论是初次询盘还是订单确认，我们的外贸极客都能为您提供强有力的支持，助力您的业务增长。",
              package1: true,
              package2: true,
              package3: true,
            },
          ],
        },
        {
          title: "服务支持",
          subTitle: "优质服务保障",
          contentList: [
            {
              title: "基础文档和培训",
              desc:
                "提供详细的系统操作指南，包括<strong>文字文档和视频教程</strong>，同时提供系统<strong>使用培训</strong>。帮助用户快速上手和深度理解系统功能，从基础设置到高级操作，全方位覆盖，确保用户在使用过程中能够自如应对各种情景，提升工作效率。",
              package1: true,
              package2: true,
              package3: true,
            },
            {
              title: "辅助实施和支持",
              desc:
                "我们提供系统<strong>初始化配置、资料素材处理和生成、网站建站、账号配置</strong>等工作。用户可随时咨询，获得技术团队的实时帮助，确保系统顺利实施和运行，大大减少因系统不熟悉而导致的操作困难和工作中断。",
              package1: false,
              package2: true,
              package3: true,
            },
            {
              title: "专业人工代运营",
              desc:
                "我们的专业团队可为客户提供代运营服务，确保系统得到充分利用。涵盖<strong>营销管理、品牌推广引流、数据或工具获客</strong>，帮助客户实现业务目标，提升客户满意度和市场竞争力。",
              package1: false,
              package2: false,
              package3: false,
            },
          ],
        },
      ],
    };
  },

  mounted() {
    // 事件监听滚动条
    // window.addEventListener('scroll', this.watchScroll);
  },

  destroyed() {
    // 移除事件监听
    // window.removeEventListener('scroll', this.watchScroll);
  },

  methods: {},
  components: {
    Abbutton,
  },
};
</script>

<style lang="sass" scoped>
.popover-desc {
  white-space: break-spaces;
  max-width: 500px;
  line-height: 30px;
  strong {
    font-weight: 500;}
  }
.ab-server .server-desc .server-desc-item .item-desc-name.ad-item-height{
height:auto;
margin-bottom: 0px;background:#fff;
margin-top:0.2rem;

.ant-col .fontsize16{
  span{
  display: block;
  padding-top:6px;
}
    line-height:24px;    font-family: Alibaba-PuHuiTi-R;
}
}
.server-desc-opacity{
  opacity: .4
}
 .ant-popover-inner-content{
   p{
     width: 280px;
     display: flex;
    em{
    width: 8px;
    height: 8px;
    background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
    display: inline-block;
    border-radius: 50%;
    position: relative;
    top: 8px;
    margin-right: 8px;
    }
    font-size: 16px;
  }
}

  .ab-fix-nav {
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .ab-hide {
    display: none;
  }

.ab-server{
  background-color: rgba(255, 255, 255, 1);
  padding-top: 81px;
  .block-title{
    height: 55px;
    font-size: 40px;
    font-family: AlibabaPuHuiTiB;
    line-height: 55px;
    text-align: center;
  }

  .block-subtitle{
    text-align: center;
    padding-top: 10px;
    height: 27px;
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    padding-bottom:30px;
    line-height: 27px;
    opacity: 0.8;
  }

  .server-list{
    margin-top: 38px;
    border: 1px solid #E4E4E5;
    .server-content {
      .server-content-item {
        align-items: center;
    display: flex;
        border-top: 1px solid #E4E4E5;
        line-height:60px;
        text-align: center;
        .item-product {
          padding-left: 40px !important;
        }
          .borderRight {
            // border-right: 1px solid #E4E4E5;
            }
        .item-name {
          // text-align: left;
          // padding-left: 20px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 500;
font-size: 18px;
color: #222222;
line-height: 48px;
        }
        .item-status {
          .iconfont {
            color: #58BD6A;
            font-size: 22px;
          }
        }
        .empty {
          color: #BBBCBD;
        }
          .item-name-title {
            font-size: 24px;}
          .item-desc {
            text-align: left;
          padding: 0 20px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 400;
font-size: 18px;
color: #222222;
line-height: 48px;
white-space: break-spaces;
            }
          .item-subtitle {
            font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 400;
font-size: 16px;
color: rgb(0,0,0,0.6);
// margin: 5px 0 24px 0;
// text-align: left;
// padding-left: 20px;
line-height: 20px;
margin-bottom: 10px;
            }
      }
    }
  }
.ant-affix .server-price{margin-top:23px;}
  .server-price{
  .ant-row{
     background: #fff;
  }

    .server-pro{
      height: 190px;
      background: #F4F9FF;
      border-left: 1px solid #E4E4E5;
      // background: rgba(214, 234, 255, 1);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 12px;
      img {
        width: 32px;
      }
      span{
        font-family: AlibabaPuHuiTiM;
        font-weight: normal;
        color: #333646;
        line-height: 160px;
      }
    }
      .price-val{
        max-width: 100%;
        height: 190px;
        background: #F4F9FF;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
        border-left: 1px solid #E4E4E5;
         align-items: center;

         .item-subtitle {
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 400;
font-size: 18px;
color: rgb(0,0,0,0.6);
margin: 5px 0 24px 0;
         }
        .item-name{
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 500;
font-size: 24px;
color: #111111;
          em{
            width: 40px;
            display:inline-block;
            line-height: 20px;
            font-family: 'Alibaba-PuHuiTi-R';
            background: #50E07B;
                top: -3px;
                position: relative;
            font-size:12px;
            text-align:center;
            color:#fff;
            border-radius: 4px;
          }
        }
        .item-price{
          font-family: AlibabaPuHuiTiM;
          font-weight: normal;
          /*color: #FF6531;*/
          color:rgba(51, 54, 70, .5);
          line-height: 38px;
          span{
            font-size:16px;
            /*text-decoration: line-through;*/
          }
        }
.orangeBg {
  background: linear-gradient( 90deg, #F08A44 0%, #F5B159 100%) !important;
}
        .item-try-btn{
          width: 218px;
          padding: 10px 0;
          text-align: center;
          background: linear-gradient( 90deg, #3789F7 0%, #55C0F9 100%);
border-radius: 8px;
          a{
            font-size:18px;
            color: #FAFCFF;
          }
        }
      }
  }

  .server-desc{
    .item-desc-name{
     /*position: sticky;*/
     /*top:280px;z-index: 1;*/
    }
    paadding: 15px 0 0 78px;
    .server-desc-item{
padding-bottom:10px;
      .item-desc-name{
        .ant-col .fontsize16{
          color:rgba(51, 54, 70, .7);
          line-height:60px;
          text-align:center;
          border-left:3px solid #fff;
        }
        i{
        &:hover{
            color:#fff;
            background:#2B68FF;
            border-radius:50%;
          }
          cursor: pointer;
          margin-left: 78px;
        }

        height: 60px;
        margin-bottom:10px;
        background: #F4F9FF;

        .desc-icon{
          width: 33px;
          position: relative;
          & img{
               position: absolute;
               width:25px;
               top: 17px;
          }
        }
        .desc-name{
          font-family: AlibabaPuHuiTiM;
          font-weight: normal;
          color: #333646;
          line-height: 60px;
          padding-left: 2.08rem;
        }
      }

      .item-row{
        &:hover .ant-col{
          color:#2B68FF
        }
        .ant-col-20{
          i{
            display: block;
          }
        }
        .ant-col-4{
          display: flex;
          flex-wrap: wrap;
          align-content: center;
        }
        .ant-col-5{

          i.icon-duidui,i.icon-chacha{
             font-size:22px;
      position: relative;
      top: 3px;color: rgb(80, 224, 123);
          }
            i.icon-chacha{
      color:#FA5151
    }
        }
        overflow-wrap: break-word;
        color: rgba(51, 54, 70, 1);
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R;
        text-align: left;
        line-height: 30px;
        padding: 7px 0px;
        display: flex;

        div:nth-child(1){
          padding-left: 78px;
        }

        div:nth-child(n + 2){
          text-align: center;
        }
      }
      .item-remark{
        background: #F4F9FF;
        padding-bottom:30px;
        margin-top:-10px;

        .block-remark{
          overflow-wrap: break-word;
          color: rgba(51, 54, 70, 1);
          font-size: 16px;
          font-family: Alibaba-PuHuiTi-R;
          text-align: left;
          padding: 10px 0px;
          padding-right:56px;
          div:nth-child(1){
            padding-left: 88px;
          }
        }
      }
    }
  }
}
</style>
